import React from "react";
import classnames from "classnames";
import RightMenu from "./RightMenu";
import middleware from "../../middleware";
import { ls } from "../wea-tools/storage";
import WindowFunc from "../wea-tools/window";
class WeaRightMenu extends React.Component {
  static displayName = "WeaRightMenu";
  static RightMenu = RightMenu;
  static defaultProps = {
    datas: [],
    width: 0,
    key: "",
    collectParams: undefined,
    className: "",
    style: {}
  };
  constructor(props) {
    super(props);
    this.instanceIsMounted = false;
    const document = this.props.enableTopWindow
      ? WindowFunc.getTop().document
      : window.document;
    this.state = {
      random: `${new Date().getTime()}_${Math.ceil(Math.random() * 100000)}`,
      visible: false,
      targetL: 0,
      targetT: 0,
      eventL: 0,
      eventT: 0,
      wrapL: 0,
      wrapT: 0,
      wrapW: 0,
      wrapH: 0,
      frameOffset: {},
      frameT: 0,
      frameL: 0,
      winW: document.body.clientWidth,
      winH: document.body.clientHeight,
      showRightMenu: true,
      activeElement: null,
      selectionStart: 0,
      selectionEnd: 0
    };
    this.onContextMenu = this.onContextMenu.bind(this);
  }
  componentDidMount() {
    const useRightMenu = this.getUseMenu();
    if (!useRightMenu) return;
    this.instanceIsMounted = true;
    const { key = "" } = this.props;
    const { random, frameOffset } = this.state;
    const iframes = $(`#wea_right_menu_wrap_${key}_${random}`).find("iframe");
    iframes.length > 0 &&
      iframes.each((index, frame) => {
        if (this.checkCrossOrigin(frame)) {
          $(frame.contentWindow).load(() => {
            // doc ready 事件不稳定。。
            frame.contentWindow[
              `wea_right_menu_${key}_${random}_frame_index`.toLocaleUpperCase()
            ] = index;
            this.setState({
              frameOffset: { ...frameOffset, [index]: $(frame).offset() }
            });
            frame.contentWindow.document.oncontextmenu = this.onContextMenu;
            this.onDocClick(frame.contentWindow.document);
          });
        }
      });
    this.onDocClick(document);

    // const onIframeContextMenu = this.onIframeContextMenu.bind(this);
    // const onIframeClick = this.onIframeClick.bind(this);
    window.addEventListener("message", this.messageHandler, false);
    if (this.RightMenu && this.RightMenu.isEmpty)
      this.setState({ showRightMenu: false });
  }

  componentWillUpdate(nextProps, nextState, nextContext) {
    if (nextState.visible != this.state.visible) {
      if (nextState.visible) {
        window.onWeaDialogOpen && window.onWeaDialogOpen();
      } else {
        window.onWeaDialogClose && window.onWeaDialogClose();
      }
    }
  }

  componentWillUnmount() {
    const useRightMenu = this.getUseMenu();
    if (!useRightMenu) return;
    this.instanceIsMounted = false;
    const { key = "" } = this.props;
    const { random } = this.state;
    const iframes = $(`#wea_right_menu_wrap_${key}_${random}`).find("iframe");
    if (this.state.visible) {
      window.onWeaDialogClose && window.onWeaDialogClose();
    }
    iframes.length > 0 &&
      iframes.each((index, frame) => {
        if (
          frame.className !== "custompageIframe" &&
          this.checkCrossOrigin(frame)
        ) {
          this.offDocClick(frame.contentWindow.document);
        }
      });
    this.offDocClick(document);
    window.removeEventListener("message", this.messageHandler);
  }
  getUseMenu = () => {
    let useRightMenu = true;
    const useRightMenuLs = ls.getJSONObj("useRightMenu") || {
      useRightMenu: "true"
    };
    if (
      "useRightMenu" in useRightMenuLs &&
      useRightMenuLs.useRightMenu === "0"
    ) {
      useRightMenu = false;
    }
    return useRightMenu;
  };
  checkCrossOrigin = iframe => {
    if (iframe.src && /^http/.test(iframe.src)) {
      const src = iframe.src.replace(/^http(s?):\/\//, "");
      if (src.indexOf(window.location.host) !== 0) {
        return false;
      }
    }
    if (/interface\/Entrance\.jsp/.test(iframe.src)) {
      return false;
    }
    if (/em_cors_frame=1/.test(iframe.src)) {
      return false;
    }
    return true;
  };
  messageHandler = event => {
    try {
      let data = JSON.parse(event.data);
      if (data.event == "oncontextmenu") {
        console.log("test");
        onIframeContextMenu(data.data);
      }
      if (data.event == "onIframeClick") {
        onIframeClick();
      }
    } catch (error) {}
  };
  docClick = () => {
    if (this.instanceIsMounted) {
      const { visible } = this.state;
      const { handleVisible } = this.props;
      visible &&
        this.setState({ visible: false }, () => {
          typeof handleVisible === "function" && handleVisible(false);
        });
    }
  };
  onDocClick(doc) {
    doc.addEventListener("click", this.docClick);
  }
  offDocClick(doc) {
    doc.removeEventListener("click", this.docClick);
  }
  onIframeClick = () => {
    if (this.instanceIsMounted) {
      const { visible } = this.state;
      const { handleVisible } = this.props;
      visible &&
        this.setState({ visible: false }, () => {
          typeof handleVisible === "function" && handleVisible(false);
        });
    }
  };
  getSelection = () => {
    if (
      document.activeElement &&
      (document.activeElement.tagName === "INPUT" ||
        document.activeElement.tagName === "TEXTAREA")
    ) {
      this.setState({
        activeElement: document.activeElement,
        selectionStart: document.activeElement.selectionStart,
        selectionEnd: document.activeElement.selectionEnd
      });
    }
  };

  onIframeContextMenu = params => {
    const targetL = params.targetL;
    const targetT = params.targetT;
    const eventL = params.eventL;
    const eventT = params.eventT;
    const frameL = params.frameL;
    const frameT = params.frameT;
    this.getSelection();
    const { handleVisible } = this.props;
    this.setState(
      {
        targetL,
        targetT,
        eventL,
        eventT,
        visible: true
      },
      () => {
        typeof handleVisible === "function" && handleVisible(true);
      }
    );
  };

  onContextMenu(e) {
    const useRightMenu = this.getUseMenu();
    if (!useRightMenu) return;
    const isIframe = !e.nativeEvent;
    const { key = "", disabled, handleVisible } = this.props;
    if (!disabled) {
      const { random, frameOffset } = this.state;
      const targetL = $(e.target).offset().left;
      const targetT = $(e.target).offset().top;
      const eventL = isIframe ? e.offsetX : e.nativeEvent.clientX - targetL;
      const eventT = isIframe ? e.offsetY : e.nativeEvent.clientY - targetT;
      let wrap = $(`#wea_right_menu_wrap_${key}_${random}`) || "";
      let wrapL = 0;
      let wrapT = 0;
      let wrapW = 0;
      let wrapH = 0;
      const _frameOffset = isIframe
        ? frameOffset[
            e.view[
              `wea_right_menu_${key}_${random}_frame_index`.toLocaleUpperCase()
            ]
          ]
        : { top: 0, left: 0 };
      const frameT = _frameOffset.top;
      const frameL = _frameOffset.left;
      const winW = document.body.clientWidth;
      const winH = document.body.clientHeight;
      if (wrap && wrap.offset) {
        if (wrap[0]) {
          wrapL = wrap.offset().left;
          wrapT = wrap.offset().top;
          wrapW = wrap[0].offsetWidth;
          wrapH = wrap[0].offsetHeight;
        } else if (e.currentTarget) {
          const box = e.currentTarget.getBoundingClientRect();
          const document = e.currentTarget.ownerDocument;
          const documentElement = document.documentElement;
          wrapL =
            box.left + documentElement.scrollLeft - documentElement.clientLeft;
          wrapT =
            box.top + documentElement.scrollTop - documentElement.clientTop;
          wrapW = e.currentTarget.offsetWidth;
          wrapH = e.currentTarget.offsetHeight;
        }
      }
      this.getSelection();
      this.setState(
        {
          targetL,
          targetT,
          eventL,
          eventT,
          wrapL,
          wrapT,
          wrapW,
          wrapH,
          frameT,
          frameL,
          winW,
          winH,
          visible: true
        },
        () => {
          typeof handleVisible === "function" && handleVisible(true);
        }
      );
    }
    e.stopPropagation && e.stopPropagation();
    e.preventDefault && e.preventDefault();
    e.nativeEvent && e.nativeEvent.preventDefault();
  }
  render() {
    // datas 菜单数据  属性 icon: 图标 ，disabled: 禁用，content: 显示内容
    const {
      width,
      children,
      key,
      className,
      style,
      handleVisible
    } = this.props;
    const {
      visible,
      random,
      targetL,
      targetT,
      eventL,
      eventT,
      wrapL,
      wrapT,
      wrapW,
      wrapH,
      frameT,
      frameL,
      winW,
      winH,
      showRightMenu,
      activeElement,
      selectionStart,
      selectionEnd
    } = this.state;
    const newWidth =
      width ||
      ($(`#weaRrightMenu_${key}_${random}`)[0]
        ? $(`#weaRrightMenu_${key}_${random}`).width()
        : 400);
    const newHeight = $(`#weaRrightMenu_${key}_${random}`)[0]
      ? $(`#weaRrightMenu_${key}_${random}`).height()
      : 400;
    let left = targetL - wrapL + eventL;
    let top = targetT - wrapT + eventT;

    left =
      left >= winW - wrapL - frameL - newWidth
        ? winW - wrapL - newWidth - 5
        : left >= wrapW - frameL - newWidth
        ? wrapW - newWidth - 2
        : left + frameL;
    top =
      top >= winH - wrapT - frameT - newHeight
        ? winH - wrapT - newHeight - 5
        : top >= wrapH - frameT - newHeight
        ? wrapH - newHeight - 2
        : top + frameT;
    const nowStyle = {
      display: visible ? "block" : "none",
      position: "absolute",
      // maxWidth: newWidth,
      left,
      top,
      ...(width ? { width } : {})
    };
    const cls = classnames({
      ["wea-right-menu"]: true,
      ["wea-right-menu-border"]: !showRightMenu,
      ["wea-right-menu-show"]: visible
    });
    const useRightMenu = this.getUseMenu();
    return (
      <div
        ecId={`${this.props.ecId}_div@tq9drh`}
        className={`wea-right-menu-wrap ${className}`}
        id={`wea_right_menu_wrap_${key}_${random}`}
        onContextMenu={this.onContextMenu}
        style={style}
      >
        {children}
        {useRightMenu && (
          <div
            ecId={`${this.props.ecId}_div@f0lq50`}
            className={cls}
            id={`weaRrightMenu_${key}_${random}`}
            style={nowStyle}
            onClick={() =>
              this.setState({ visible: false }, () => {
                typeof handleVisible === "function" && handleVisible(false);
              })
            }
          >
            <RightMenu
              ecId={`${this.props.ecId}_RightMenu@uwssvg`}
              {...this.props}
              ref={el => (this.RightMenu = el)}
              activeElement={activeElement}
              selectionStart={selectionStart}
              selectionEnd={selectionEnd}
              isRM={true}
              showReport={true}
            />
          </div>
        )}
      </div>
    );
  }
}

const Com = middleware(WeaRightMenu, "WeaRightMenu");
export default Com;



// WEBPACK FOOTER //
// ./ecology9/wea-right-menu/index.js